import React from "react";

function FemaleExpressionless() {
  return (
    <>
      <path
        d="m 257.70788,321.46372 c -17.4,-2.82 -32.55,8.47 -32.55,8.47 0,9 14.57,17.72 32.55,17.72 v 0 c 18,0 32.54,-8.73 32.54,-17.72 0,0 -15.15,-11.29 -32.54,-8.47 z"
        id="path693"
        style={{ fill: "#d54545" }}
      />
      <path
        d="m 280.85788,330.70372 h -39.38 a 5.89,5.89 0 0 1 2.73,-3.36 49.22,49.22 0 0 1 20.94,-6.28 34.89,34.89 0 0 0 -7.44,0.4 c -17.39,-2.82 -32.55,8.47 -32.55,8.47 0,9 14.57,17.72 32.55,17.72 a 56.26,56.26 0 0 0 7.46,-0.51 c -10.46,-1.44 -19,-5.81 -22.85,-11 a 6,6 0 0 1 -0.87,-1.77 h 39.41 a 1.82,1.82 0 1 0 0,-3.63 z"
        id="path695"
        style={{ fill: "#c11e1e" }}
      />
    </>
  );
}

export default FemaleExpressionless;
